import { makeApiMutation } from "@web-monorepo/fetchers";
import type { paths } from "@web-monorepo/api-types";

export type ParentReferralIneligibilityReason =
  | "alreadyTakenOrBookedSubscriptionClass"
  | "selfReferral"
  | "previouslyEarnedReferralAward"
  | "upcomingClassScheduled"
  | "tutor"
  | "invalidCode";

const PARENT_REFERRAL_REDEEM_API_PATH = "/api/marketplace/parent/redeem-referral";

export type ParentReferralRedeemResponse =
  paths[typeof PARENT_REFERRAL_REDEEM_API_PATH]["post"]["responses"][200]["content"]["application/json"];

type ParentReferralRedeemIneligibleReason = Extract<ParentReferralRedeemResponse, { result: "ineligible" }>["reason"];

const PARENT_REFERRAL_INELIGIBILITY_REASON_BY_BACKEND_REASON: Record<
  ParentReferralRedeemIneligibleReason,
  ParentReferralIneligibilityReason
> = {
  ATTENDED_SUBSCRIPTION_CLASS: "alreadyTakenOrBookedSubscriptionClass",
  SELF_REFERRAL: "selfReferral",
  UPCOMING_CLASS_SCHEDULED: "upcomingClassScheduled",
  IS_TUTOR: "tutor",
  INVALID_CODE: "invalidCode",
};

const useRedeemParentReferralMutation = makeApiMutation({
  name: "redeemParentReferral",
  method: "post",
  path: PARENT_REFERRAL_REDEEM_API_PATH,
  // Surface unexpected network failures to the mutation's onError handler (which renders a
  // generic toast) instead of throwing them at the nearest React error boundary.
  catchError: (error) => error,
});

export function getParentReferralIneligibilityReasonFromResponse(
  response: ParentReferralRedeemResponse,
): ParentReferralIneligibilityReason | undefined {
  if (response.result === "already_granted" && !response.recipientClaim) {
    return "previouslyEarnedReferralAward";
  }
  if (response.result === "ineligible") {
    return PARENT_REFERRAL_INELIGIBILITY_REASON_BY_BACKEND_REASON[response.reason];
  }
  return undefined;
}

export default useRedeemParentReferralMutation;
